<template>
  <div class="content if-profile report-tab">
    <div class="md-layout finanical-insights-body">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header m-0">
        <CRHeader :headerData="this.headerData"/>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0">
        <div class="navbar md-toolbar md-transparent md-elevation-4 p-0">
          <div class="md-toolbar-row p-0">
            <nav-tabs-card>
              <template slot="content">
                <div class="md-layout">
                  <!-- <div class="md-toolbar-row map-box-title">
                    <div class="md-layout">
                      <md-card-header class="md-card-header-icon">
                        <h1 class="md-title text-left profile-title">
                          SWOT-XPRESS SCORING EXPLAINED
                        </h1>
                      </md-card-header>
                    </div>
                  </div>-->
                  <div class="md-layout company-terms">
                    <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
                      <md-card class="if_card">
                        <md-card-header class="md-card-header-icon">SWOT-XPRESS Scoring Explained</md-card-header>
                        <md-card-content>
                          <div class="extra_space">
                            <p>
                              In most cases, the variance for each metric
                              measures the percentage difference between input
                              firm ratios and the industry average. The Sales
                              per Household Market Opportunity Index and
                              Location Quotient compare local and national
                              market data to determine the variance between the
                              two. Each variance results in a Score of 1-5 (5
                              being best) for each year of each selected ratio.
                              The application of the Variances to the Score
                              depends on the specific metric; in most cases
                              higher is better (Standard Scoring); in some,
                              lower (Reverse Scoring) is better; in a few,
                              closest to the industry average (Balanced Scoring)
                              is best.
                              <br />
                              <br />
                            </p>
                          </div>
                          <div class="md-layout px-4">
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <md-card class="md-card-profile">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Approach to Scored SWOT Metrics:</div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="extra_space">
                                    <ul>
                                      <li>Owner Earnings (%)-Standard</li>
                                      <li>Sales Rank -Standard</li>
                                      <li>Variance from Average Sales-Standard</li>
                                      <li>
                                        Variance from Small Business
                                        Sales-Standard
                                      </li>
                                      <li>
                                        Sales per Household Market
                                        OpportunityIndex-Standard
                                      </li>
                                      <li>Location Quotient-Reverse</li>
                                      <li>Sales per Employee Index-Standard</li>
                                      <li>Efficiency Index-Standard</li>
                                      <li>Days Receivable-Reverse</li>
                                      <li>Current Ratio-Standard</li>
                                      <li>Current Liabilities:Net Worth-Reverse</li>
                                      <li>Long Term Liabilities: Net Worth-Reverse</li>
                                      <li>Total Liabilities:Net Worth-Reverse</li>
                                      <li>Days Payable-Balanced</li>
                                      <li>Modified Z‐Score-Standard</li>
                                    </ul>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                            <div class="md-layout-item md-medium-size-100 md-size-50">
                              <md-card class="md-card-profile">
                                <md-card-header>
                                  <h4 class="title m-0">
                                    <div
                                      class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                                    >Scoring Calculations:</div>
                                  </h4>
                                </md-card-header>
                                <md-card-content>
                                  <div class="extra_space">
                                    <h5 class="color-blue">
                                      <strong>
                                        Standard (basically higher is
                                        better)
                                      </strong>
                                    </h5>
                                    <ul>
                                      <li>+/-10% from average= 3</li>
                                      <li>+11% to +20% above average= 4</li>
                                      <li>>20% above average= 5</li>
                                      <li>+11% to +20% below average= 2</li>
                                      <li>>20% below average= 1</li>
                                    </ul>
                                    <h5 class="color-blue">
                                      <strong>Reverse (lower is better)</strong>
                                    </h5>
                                    <ul>
                                      <li>+/-10% from average= 3</li>
                                      <li>+11% to +20% above average= 2</li>
                                      <li>>20% above average= 1</li>
                                      <li>+11% to +20% below average= 4</li>
                                      <li>>20% below average= 5</li>
                                    </ul>
                                    <h5 class="color-blue">
                                      <strong>
                                        Balanced (middle is good, too high or
                                        too low is not)
                                      </strong>
                                    </h5>
                                    <ul>
                                      <li>+/-10% from average= 5</li>
                                      <li>11% to 15% above or below average= 4</li>
                                      <li>+16% to +25% above or below average= 3</li>
                                      <li>25%-30% above or below average= 2</li>
                                      <li>30% above or below average= 1</li>
                                    </ul>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                          </div>
                        </md-card-content>
                      </md-card>
                    </div>
                  </div>
                </div>
              </template>
            </nav-tabs-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CRHeader from './CRHeader.vue';
import { NavTabsCard } from '@/components';
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    NavTabsCard,
    CRHeader,
  },

  computed: {
    user() {
      return this.$store.state.user.user;
    },
    companyReportSummary() {
      return this.$store.getters['user/companyReport'];
    },
  },
  props:['headerData'],
  methods: {

    companyReport() {
      return this.$store.getters['user/companyReport'];
    },
    switchView: function (type) {
      this.view = type;
    },
  },
};
</script>

<style lang="scss"></style>
